export const IMAGES = {
  brdLogo: "https://customer-assets.emergentagent.com/job_isic-card-benefits/artifacts/qnijo0bb_BRD_logo.svg.webp",
  isicLogo: "https://customer-assets.emergentagent.com/job_isic-card-benefits/artifacts/bcfjcmyb_ISIC_logo_COLOUR_rgb.png",
  card: "https://customer-assets.emergentagent.com/job_bcf34023-7112-45b9-9c62-0f0e685c5e11/artifacts/e0fvi24n_BRD_ISIC_2021_front.jpg",
  aliveApp: "https://customer-assets.emergentagent.com/job_bcf34023-7112-45b9-9c62-0f0e685c5e11/artifacts/syl76qks_aliveapp1_newEN.webp",
  appStore: "https://customer-assets-rejwkqb3.emergentagent.net/job_isic-card-benefits/artifacts/270kr0dk_Asset%2024x.webp",
  googlePlay: "https://customer-assets-rejwkqb3.emergentagent.net/job_isic-card-benefits/artifacts/5f10szix_Asset%2014x.webp",
};

export const LINKS = {
  appStore: "https://apps.apple.com/us/app/alive-app/id1550658938?utm_source=aliveapp.net&utm_medium=referral",
  googlePlay: "https://play.google.com/store/apps/details?id=com.bootiq2.gtsisic&referrer=utm_source%3Daliveapp.net%26utm_medium%3Dreferral%26anid%3Dadmob",
  discountsRo: "https://www.isic.ro/reduceri/local/?dmLimit=10&dmSortKey=views&dmSortOrder=desc&dmSeed=3100&dmDisplay=images",
  discountsIntl: "https://www.isic.org/discounts/",
};

export const NATIONAL_PARTNERS = [
  {
    name: "Penny",
    offer: "10% reducere",
    logo: "https://academic.isic.ro/assets/logo-penny.webp",
    link: "https://www.isic.ro/reduceri/ro/penny/9679",
  },
  {
    name: "Starbucks",
    offer: "20% reducere la băuturi și gustări",
    logo: "/assets/ro/logo-starbucks.png",
    link: "https://www.isic.ro/reduceri/ro/starbucks/10799",
  },
  {
    name: "IKEA",
    offer: "10% reducere la cardurile cadou",
    logo: "https://academic.isic.ro/assets/logo-ikea.png",
    link: "https://www.isic.ro/reduceri/ro/ikea/6994",
  },
  {
    name: "Spotify",
    offer: "Ofertă specială pentru studenți",
    logo: "https://academic.isic.ro/assets/logo-spotify.webp",
    link: "https://www.isic.ro/reduceri/ro/spotify/9056",
  },
  {
    name: "Christian Tour",
    offer: "Travel Prime gratuit, în loc de 79€ pe an",
    logo: "https://academic.isic.ro/assets/logo-christian-tour.png",
    link: "https://www.isic.ro/reduceri/ro/christian-tour/10378",
  },
  {
    name: "Carrefour",
    offer: "7% reducere",
    logo: "https://academic.isic.ro/assets/logo-carrefour.webp",
    link: "https://www.isic.ro/reduceri/ro/carrefour/7921",
  },
  {
    name: "Burger King",
    offer: "15% reducere",
    logo: "https://academic.isic.ro/assets/logo-burger-king.png",
    link: "https://www.isic.ro/reduceri/ro/burger-king/6921",
  },
  {
    name: "Sephora",
    offer: "20% reducere la Sephora Collection",
    logo: "https://academic.isic.ro/assets/logo-sephora.webp",
    link: "https://www.isic.ro/reduceri/ro/sephora/10161",
  },
  {
    name: "World Class",
    offer: "Până la 40€ reducere la abonamente",
    logo: "https://academic.isic.ro/assets/logo-worldclass.png",
    link: "https://www.isic.ro/reduceri/ro/world-class/3579",
  },
];

export const INTL_DESTINATIONS = [
  { name: "Berlin — The Wall Museum", image: "https://academic.isic.ro/assets/intl-wall.png" },
  { name: "Paris — Disneyland", image: "https://academic.isic.ro/assets/intl-disneyland.png" },
  { name: "Roma — Muzeele Vaticane", image: "https://academic.isic.ro/assets/intl-vatican.png" },
  { name: "Madrid — Muzeul Prado", image: "https://academic.isic.ro/assets/intl-prado.png" },
  { name: "Paris — Arcul de Triumf", image: "https://academic.isic.ro/assets/intl-paris.png" },
];


